import Header from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import '../../mixins.js'
import spinner from "../LoadingComponent/LoadingComponent.vue"
import CookieLaw from 'vue-cookie-law'
import SideBar from "../SideBar/SideBar.vue"


export default {
  name: 'user-page',
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    spinner: spinner,
    CookieLaw,
    SideBar
    
  },
  props: [],
  data () {
    return {
      isLoaded: false,
      tokenValid: false,
      riskType: "Mittel",
      //brokers: [],//["Comdirect", "OnVista", "Trade Republic", "ING Diba", "Consorsbank"],
      mailAddress: "loading...",
      isModalDelAccountVisible: false,
      isModalChangeMailVisible: false,
      isModalChangePasswordVisible: false,
      isPasswordEqual: true,
      isMailValid: true,
      password: null,
      password_confirmation: null,
      new_mail: null,
      isPasswordUpdateSuccessful: false,
      isMailUpdateSuccessful: false,
      inputChecked:[],
      broker_list: [],
      showButtonSpinner: false,
      isEndpointError: false,
      isBrokerUpdateSuccessful: false,
    }
  },
  computed: {

  },
  async created() {
    await this.loadData()
  },
  mounted () {

  },


  methods: {
    loadData: async function(){

      var response = await this.accessEndpoint('accountInformation/');
      var brokers = response.brokers
      console.log("active brokers", brokers)
      var available_brokers = response.available_brokers
      this.broker_list = []
      available_brokers.forEach(broker => {
        this.broker_list.push({name:broker, active: brokers.includes(broker)})
      })
      console.log(this.broker_list)
      this.mailAddress = response.email;
      this.isLoaded = true;

    },
    
    closeModal: function(){
      this.isModalChangeMailVisible = false;
      this.isModalChangePasswordVisible = false;
      this.isModalDelAccountVisible = false;
    },
    sendPassword: async function(){
      let payload = {
        'password': this.password,
        'password_confirmation': this.password_confirmation
      }
      this.verifyPassword()
      await this.postEndpoint(payload, 'changePassword/');
      await this.loadData()
      this.closeModal()
      
      setTimeout(() => this.isPasswordUpdateSuccessful = true, 200)

      setTimeout(() => this.isPasswordUpdateSuccessful = false, 3000)
    },
    sendNewMail: async function(){
      let payload = {
        'email': this.new_mail
      }
      this.verifyMailAdress()
      await this.postEndpoint(payload, 'changeEmail/');
      await this.loadData()
      this.closeModal()
      setTimeout(() => this.isMailUpdateSuccessful = true, 200)

      setTimeout(() => this.isMailUpdateSuccessful = false, 3000)
    },
    deleteAccount: async function(){
      let payload = {
        'email': this.new_mail
      }

      await this.deleteAccountEndpoint(payload,'deleteAccount/')
      this.closeModal()
      this.$router.push("/");
    },
    verifyPassword(){
      if(this.password == this.password_confirmation){
        this.isPasswordEqual = true;
      }
      else{
        this.isPasswordEqual = false;
        return false;
      }
    },
    verifyMailAdress(){
      if(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.new_mail)){
        this.isMailValid = true;
      }
      else{
        this.isMailValid = false;
        return false;
      }
    },
    async saveBrokers(){
      this.showButtonSpinner = true
      var selected_brokers = [];
      this.broker_list.forEach(broker_json => {
        if(broker_json.active == true){
          selected_brokers.push(broker_json.name)
        }
      })
      let payload = {
        "broker_names": selected_brokers
      }
      try{
        await this.verifyToken();
        await this.postEndpoint(payload, 'changeBroker/');
        setTimeout(() => this.isBrokerUpdateSuccessful = true, 200)

        setTimeout(() => this.isBrokerUpdateSuccessful = false, 3000)
      }catch{
        this.showErrorNotification()
      }
      
      this.showButtonSpinner = false;

    }
  }
}


